import React, {Component} from 'react';
import {Breadcrumb, BreadcrumbItem, Input,Button,Card,CardImg } from "reactstrap";
import {Link} from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';


import ContactMap from "../../components/map/ContactMap";

// import "./../../assets/images/banner-contact.jpg";

const pageTitle = "Contact us";

export default class ContactUs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            massage: ''
        };
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.state.massage !== ""){
            toast.success('Your request has been send successful, we will contact you soon ... ', {position: toast.POSITION.TOP_LEFT});
        }else{
            toast.error('Please fill all field before submit. ', {position: toast.POSITION.TOP_LEFT});

        }

        /*axios.post('/contact',{name:this.state.name,email:this.state.email, massage:this.state.massage})
            .then(function(response){
                console.log(response);
            })*/
    }


    render() {
        return (
            <div >

                <div className="jumbotron text-center rtl contact-page-header">

                    <div className="container d-flex justify-content-start align-self-stretch  mt-5">
                        <div className="p-2 text-right rtl">
                            <h1 className="pag-title">{pageTitle}</h1>
                        </div>
                        <div className="ml-auto p-2">
                            <Breadcrumb className="">
                                <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                                {/*<BreadcrumbItem><a href="#">محصولات</a></BreadcrumbItem>*/}
                                <BreadcrumbItem active>{pageTitle}</BreadcrumbItem>
                            </Breadcrumb>

                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row">

                        <div className="col-sm-12 mb-5" style={{minHeight:615}}>
                            <ContactMap />
                        </div>

                        <div className="col-md-6">
                            <br/>
                            <br/>
                            <br/>
                            <Card cascade>
                                <CardImg  tag="div">
                                    <div className="view gradient-card-header blue-gradient p-3" style={{backgroundColor:"#e9edef"}}>
                                        {/*<p><strong>آدرس:</strong></p>*/}
                                        <p><strong>Phone Number :</strong> +989133160903 | +989103004875 </p>
                                        <p><strong>Email :</strong> <a href="mailTo:info@iranroute.com">info@iranroute.com</a></p>
                                        <p><strong>Address :</strong>  Isfahan, Iran</p>

                                    </div>
                                </CardImg>
                            </Card>



                        </div>
                        <div className="col-md-6">
                            <h2 className="mb-5">Contact us</h2>
                            <form onSubmit={this.handleSubmit.bind(this)}>
                                <Input placeHolder="Name"  group type="text" validate error="wrong" success="right"  />
                                <br/>

                                <Input placeHolder="Email"  group type="email" validate error="wrong" success="right" value={this.state.email}  onChange={e => this.setState({ email: e.target.value })}/>
                                {/*<Input label="موضوع" group type="email" validate error="wrong" success="right"/>*/}
                                <br/>
                                <Input type="textarea" placeHolder="Message" value={this.state.massage} onChange={e => this.setState({ massage: e.target.value })}/>
                                <div className="text-right">
                                    <br/>

                                    <Button type="submit" value="Submit" color="primary" style={{fontWeight:"bold"}}>Send <i  className="fa fa-paper-plane-o ml-1"/></Button>
                                </div>
                            </form>

                            <ToastContainer
                                hideProgressBar={true}
                                newestOnTop={true}
                                autoClose={5000}

                            />
                        </div>
                    </div>
                    <div className="row">
                        <br/>
                        <br/>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/contact/ContactUs.js